module.exports = __webpack_public_path__ + "img/2_160.2681bd0d.png";